export enum EnInviteStatus {
    sent = 'sent',
    accepted = 'accepted',
    expired = 'expired'
}
